import React, { useState } from 'react';
import { Drawer, Form, Input, Button, Space } from 'antd';
import { DealsApi } from 'api/api';
import { useTranslation } from 'react-i18next';
import FeatherIcon from 'feather-icons-react';
import styled from 'styled-components';

const dealsApi = new DealsApi();

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px;
  }
`;

interface Props {
  visible: boolean;
  dealId: number;
  onSuccess: () => void;
  onClose: () => void;
}

const AddNoteDrawer: React.FC<Props> = ({
  visible,
  dealId,
  onSuccess,
  onClose,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await dealsApi.apiDealsIdNotesPost({
        id: dealId,
        addDealNoteCommand: {
          dealId,
          content: values.content,
        },
      });

      form.resetFields();
      onSuccess();
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledDrawer
      title={t('deals:add-note', 'Add Note')}
      placement="right"
      onClose={onClose}
      visible={visible}
      width={400}
      extra={
        <Space>
          <Button onClick={onClose}>
            {t('global:cancel', 'Cancel')}
          </Button>
          <Button 
            type="primary" 
            onClick={handleSubmit}
            loading={loading}
            icon={<FeatherIcon icon="save" size={16} />}
          >
            {t('global:save', 'Save')}
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="content"
          rules={[
            { required: true, message: t('deals:note-content-required', 'Please enter note content') },
            { min: 3, message: t('deals:note-content-min', 'Note must be at least 3 characters long') },
          ]}
        >
          <Input.TextArea
            rows={6}
            placeholder={t('deals:note-placeholder', 'Write your note here...')}
          />
        </Form.Item>
      </Form>
    </StyledDrawer>
  );
};

export default AddNoteDrawer;